// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1276bd44","453":"d855a71b","455":"3248cb81"}[chunkId] + ".chunk.js";
};